<div
  class="bg-bluegray-100 fixed bottom-0"
  [class.notification-panel]="!isLk"
  [class.notification-panel-lk]="isLk"
  [class.w-full]="isLk"
  [class.minimized]="minimized && !isLk"
  style="z-index: 1000"
>
  <div
    class="px-3 flex flex-wrap align-items-center"
    [class.py-1]="!isLk"
    [class.py-2]="isLk"
    [class.notification-panel-body-lk]="isLk"
  >
    <div class="notification-grid" [class.notification-grid-lk]="isLk" [class.p-2]="!isLk">
      <crm-global-search *ngIf="!isLk"></crm-global-search>
      <nav *ngIf="isLk" class="lk-docs" aria-label="Документы">
        <a target="_blank" routerLink="/assets/docs/rules.pdf" class="lk-doc-link">
          <i class="pi {{ 'pdf' | mime }}" aria-hidden="true"></i>
          <span>ПРАВИЛА Атриум</span>
        </a>
        <a target="_blank" routerLink="/assets/docs/management.pdf" class="lk-doc-link">
          <i class="pi {{ 'pdf' | mime }}" aria-hidden="true"></i>
          <span>Руководство по отделке</span>
        </a>
      </nav>
    </div>
    <div class="notification-icons flex" [class.notification-icons-lk]="isLk">
      <crm-notification-list
        [icon]="'pi-book'"
        header="Заявки"
        [informerType]="InformerType.TASK"
        [compact]="isLk"
      ></crm-notification-list>
      <crm-notification-list
        [icon]="'pi-id-card'"
        header="Каталог"
        [informerType]="InformerType.CATALOG"
        [compact]="isLk"
      ></crm-notification-list>
      <crm-notification-list
        [icon]="'pi-dollar'"
        header="Бюджет"
        [informerType]="InformerType.BUDGET"
        [compact]="isLk"
      ></crm-notification-list>
      <crm-notification-list
        [icon]="'pi-info-circle'"
        header="ОФД"
        [informerType]="InformerType.SYSTEM"
        [compact]="isLk"
      ></crm-notification-list>
    </div>
  </div>
</div>

<p-toast key="notification" position="bottom-right" styleClass="notification-toast" #toast>
  <ng-template let-message pTemplate="message">
    <div
      *ngIf="toSocketNotification(message.data) as notification"
      class="w-full cursor-pointer"
      (click)="onNotificationClick(toast, notification)"
    >
      <h4 class="mt-0 mb-3 fw-bold">{{ notification.entity?.name || 'Новое уведомление' }}</h4>
      <h4 class="mt-0 mb-1 fw-semibold">{{ notification?.user.name }}</h4>
      <p class="notification-text break-word">{{ notification.text | truncate: 70 }}</p>
    </div>
  </ng-template>
</p-toast>
